// extracted by mini-css-extract-plugin
export default {"titleText":"SignUpSegmentSelector_titleText__3H5Bl"};